import React from 'react';
import { Toggle as KToggle } from '@ui-kitten/components';
const Kitten = (props) => {
    const { text, checked, onPress, size, ...rest } = props;
    return (<KToggle text={text} checked={checked} onChange={onPress} size={size} {...rest}/>);
};
export default {
    Kitten,
};
//# sourceMappingURL=Toggle.js.map